module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"title":"Não foi possível finalizar o pagamento.","text":"Algo inesperado aconteceu. \\nVocê pode voltar ou atualizar essa página e tentar outra vez."},"en-US":{"title":"Unable to complete payment.","text":"Something unexpected happened.\\nYou can go back or refresh this page and try again."}}')
  delete Component.options._Ctor
}
